import { RAddress } from '../remote/address';
import { Address } from '../domain/address';
import { SyncState } from '../../../General/domain/general';

export function mapAddress(address: RAddress): Address {
    return {
        id: address.id,
        fullAddress: address.fullAddress,
        latitude: address.latitude,
        longitude: address.longitude,
        syncState: SyncState.Synced
    };
}

export function mapAddressToRAddress(address: Address): Partial<RAddress> {
    return {
        id: address.syncState === SyncState.New ? undefined : address.id,
        fullAddress: address.fullAddress,
        latitude: address.latitude,
        longitude: address.longitude
    };
}
